module.exports = __webpack_public_path__ + "fonts/iconfont.ea04030.woff";